// extracted by mini-css-extract-plugin
export default {"cards":"styles_cards__DIGmB"};